var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48633 7.9888H14.4349",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48633 10.562H14.4349",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48633 13.1353H11.3466",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48633 15.7095H9.2878",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5353 17.7671V19.8269C16.5353 20.3931 16.0721 20.8563 15.5059 20.8563H6.41515C5.84898 20.8563 5.38574 20.3931 5.38574 19.8269V5.41515C5.38574 4.84898 5.84898 4.38574 6.41515 4.38574H15.5059C16.0721 4.38574 16.5353 4.84898 16.5353 5.41515V8.96405",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9248 11.1191L19.0577 13.2526",
    stroke: "#F25C54",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6747 18.595C11.5887 18.595 11.5048 18.5616 11.4431 18.4988C11.3623 18.4185 11.3298 18.3027 11.3551 18.192L11.8322 16.1682C11.8461 16.1085 11.8765 16.0539 11.9197 16.0112L17.9526 9.97832C18.3242 9.6067 18.9732 9.60567 19.3448 9.97832L19.9635 10.597C20.1498 10.7828 20.2523 11.0304 20.2523 11.2929C20.2523 11.5559 20.1498 11.804 19.9635 11.9893L13.9306 18.0221C13.8874 18.0654 13.8328 18.0952 13.7742 18.1096L11.7503 18.5863C11.7251 18.5924 11.6999 18.595 11.6747 18.595Z",
    stroke: "#231D1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInfoIcon);
export default __webpack_public_path__ + "static/media/HealthInfo-icon.b0a9bcaa2cc8a7cd2e445e2c2195370f.svg";
export { ForwardRef as ReactComponent };